"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AllowedHubs = _interopRequireDefault(require("./AllowedHubs"));

var _HubsToPath;

var HubsToPath = (_HubsToPath = {}, (0, _defineProperty2.default)(_HubsToPath, _AllowedHubs.default.HUBS_CAMPAIGN, 'hubs_campaign'), (0, _defineProperty2.default)(_HubsToPath, _AllowedHubs.default.HUBS_CONTENT, 'hubs_content'), (0, _defineProperty2.default)(_HubsToPath, _AllowedHubs.default.HUBS_CTA, 'hubs_cta'), (0, _defineProperty2.default)(_HubsToPath, _AllowedHubs.default.HUBS_MEDIUM, 'hubs_medium'), (0, _defineProperty2.default)(_HubsToPath, _AllowedHubs.default.HUBS_SIGNUP_URL, 'hubs_signup-url'), (0, _defineProperty2.default)(_HubsToPath, _AllowedHubs.default.HUBS_SOURCE, 'hubs_source'), _HubsToPath);
var _default = HubsToPath;
exports.default = _default;
module.exports = exports.default;